import dynamic from "next/dynamic";

export const DynamicContent056 = dynamic(() => import("./Content056"), {
  suspense: true,
});
